<mat-form-field class="example-full-width" appearance="fill"  [id]="activity.inputControlID">
  <input
    #numericBox
    matInput
    type="text"
    appAllowNumbersOnly
    limitDecimalDigits
    [attr.width]="activity.controlWidth"
    [attr.maxlength]="activity.maxLength"
    name="ans"
    [placeholder]="activity.hint"
    [formControl]="activityControl"
    [required]="activity.isRequired"
    [pattern]="decimalPattern"
    autocomplete="off"/>

  <mat-error class="m-top-8" *ngIf="activityControl.hasError('required')">
    {{ "Required" | translate }}*
  </mat-error>
  <mat-error class="m-top-8" *ngIf="activityControl.hasError('pattern')&& activity.decimalLimit != 0">
    {{ "NumTextBoxErrorMsg" | translate: { decimalPlaces: decimalLimit} }}
  </mat-error>
  <mat-error class="m-top-8" *ngIf="activityControl.hasError('pattern')&& activity.decimalLimit == 0">
    {{ "NumberAllowed" | translate }}
  </mat-error>
  <mat-error class="m-top-8" *ngIf="activityControl.hasError('max')">
    {{ "MaxValueErrorMsg" | translate }} {{activity['customMaxMin'] ? activity['customMaxMin']: activity.maxValue}}
  </mat-error>

  <mat-error class="m-top-8" *ngIf="activityControl.hasError('min')">
    <ng-container *ngIf="minValue > 0.01 else nonzero">
      {{'MinValueErrorMsg' | translate}} {{activity['customMaxMin'] ? activity['customMaxMin']: activity.minValue}}
    </ng-container>
    <ng-template #nonzero>
      {{'CONTACT_INFO_COMPONENT.INVALID_ENTRY' | translate}}
    </ng-template>
    </mat-error>
</mat-form-field>
